<template>
  <!-- 新增v-if="open"為了讓他重啟時刷新狀態 -->
  <div class="modal fade changeCRM is-open" v-if="compareArray.length > 0">
    <!------------------------ 步驟一start ---------------------------->
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">重要提醒</h3>
        </div>
        <div class="modal-body px_10">
          <!-- -------------------主要區塊start ----------------------->
          <section class="container search">
            <h4 class="changeCRM__title">客戶的以下資料已變更</h4>
            <div class="changeCRM__subtitle mt_5">
              將以CRM的最新資料重新試算建議書
            </div>
            <div class="changeCRM__comparison mt_10">
              <div class="changeCRM__comparison__role">
                {{ compareArray[nowIndex].role }}
              </div>
              <div class="changeCRM__comparison__title mt_15 mb_5">
                ● CRM最新資料
              </div>
              <div class="changeCRM__comparison__item new">
                <div :key="compareArray[nowIndex].new.insured_name">
                  姓名：{{ truncate(compareArray[nowIndex].new.insured_name) }}
                </div>
                <div>
                  性別：{{
                    gender_no(compareArray[nowIndex].new.insured_gender)
                  }}
                </div>
                <div class="d-flex">
                  <div style="width: 150px" class="mr_10">
                    生日：{{
                      compareArray[nowIndex].new.insured_birthday == ""
                        ? "--"
                        : formatDate(
                            compareArray[nowIndex].new.insured_birthday
                          )
                    }}
                  </div>
                  <div>
                    年齡： {{ compareArray[nowIndex].new.insured_age }}歲
                  </div>
                </div>
              </div>
              <div class="changeCRM__comparison__title mt_10 mb_5">
                ● 建議書資料
              </div>
              <div class="changeCRM__comparison__item old">
                <div :key="compareArray[nowIndex].old.insured_name">
                  姓名：{{ truncate(compareArray[nowIndex].old.insured_name) }}
                </div>
                <div>
                  性別：{{
                    gender_no(compareArray[nowIndex].old.insured_gender)
                  }}
                </div>
                <div class="d-flex">
                  <div style="width: 150px" class="mr_10">
                    生日：{{
                      compareArray[nowIndex].old.insured_birthday == ""
                        ? "--"
                        : formatDate(
                            compareArray[nowIndex].old.insured_birthday
                          )
                    }}
                  </div>
                  <div>
                    年齡：{{ compareArray[nowIndex].old.insured_age }}歲
                  </div>
                </div>
              </div>
            </div>
            <div class="action text-right mt_10">
              <button
                type="submit"
                class="btn btn-default mr_10"
                @click="$emit('cancel')"
              >
                取消
              </button>
              <button
                type="submit"
                class="btn btn-primary"
                @click="nextHandler()"
              >
                確定
              </button>
            </div>
          </section>

          <!-- -------------------主要區塊end ----------------------->
        </div>
      </div>
    </div>
    <!------------------------ 步驟一end ---------------------------->
  </div>
</template>

<script>
import Avatar from "@/desktop/components/Avatar";
import { mapGetters, mapActions } from "vuex";
import mf_Mixin from "@/desktop/views/mf/mixin";
export default {
  name: "ChangePopup",
  mixins: [mf_Mixin],
  props: ["crmMapList", "oldCrmMapList"],
  components: { Avatar },

  data() {
    return {
      nowIndex: 0,
      compareArray: [],
    };
  },
  computed: {
    ...mapGetters(["CustInfo", "UserInfo"]),
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      for (let key in this.oldCrmMapList) {
        let role = [];
        if (this.oldCrmMapList[key].is_insurer) {
          role.push("要保人");
        }
        if (this.oldCrmMapList[key].is_insured) {
          role.push("主約被保人");
        }
        if (this.oldCrmMapList[key].is_scInsured) {
          role.push(`附約被保人`);
        }
        this.compareArray.push({
          old: this.oldCrmMapList[key],
          new: this.crmMapList[key],
          role: role.join("、"),
        });
        setTimeout(() => {
          this.registerHanlink();
        }, 100);
      }
    },
    nextHandler() {
      if (this.compareArray[this.nowIndex + 1]) {
        this.nowIndex++;

        setTimeout(() => {
          this.registerHanlink();
        }, 100);
      } else {
        this.$emit("finish");
        this.$toast.info({
          title: "客戶的最新資料與試算保費已帶入成功，請繼續操作!",
        });
      }
    },
    gender_no(value) {
      return value == "1" ? "男" : "女";
    },
  },
};
</script>

<style lang="scss">
.changeCRM {
  &__title {
    font-size: 20px;
    color: #027a39;
  }
  &__subtitle {
    font-size: 20px;
    color: #323a45;
  }
  &__comparison {
    width: 100%;
    height: 438px;
    padding: 16px 20px;
    border: solid 1px #53c480;
    background-color: #fff;
    &__role {
      border-radius: 4px;
      background-color: rgba(245, 136, 24, 0.15);
      line-height: 42px;
      padding: 0 20px;
      font-weight: 700;
      color: #323a45;
    }
    &__title {
      padding: 0 20px;
      font-weight: 700;
    }
    &__item {
      width: 660px;
      height: 126px;
      border-radius: 4px;
      padding: 0 40px;
      & > div {
        line-height: 42px;
      }
    }
    &__item.new {
      background-color: #e5f6ec;
      font-weight: 700;
    }
    &__item.old {
      background-color: #f5f5f5;
    }
  }
}
</style>
